import { render, staticRenderFns } from "./properties.vue?vue&type=template&id=32dc7e02&scoped=true&"
import script from "./properties.vue?vue&type=script&lang=ts&"
export * from "./properties.vue?vue&type=script&lang=ts&"
import style0 from "./properties.vue?vue&type=style&index=0&id=32dc7e02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dc7e02",
  null
  
)

export default component.exports